<template>
  <v-card
    class="fieldset-card"
    :class="{ dense }"
    :rounded="dense ? 0 : undefined"
    variant="outlined"
  >
    <v-card-text>
      <fieldset>
        <legend v-if="label">
          <h3 class="text-h3 fieldset-title">
            {{ label }}
          </h3>
        </legend>

        <slot />
      </fieldset>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
defineProps<{
  label?: string
  dense?: boolean
}>();
</script>

<style scoped lang="scss">
@use '~/assets/styles/variables' as *;

fieldset {
  border: none;
}

.fieldset-card {
  border: none;
  @include field-border($form-border-base-color, 1px);
}

.fieldset-card.dense {
  @include field-border($form-border-base-color, 2px);
  padding: 1px;
}

.fieldset-card.dense .v-card-text {
  padding: 0;
}

.fieldset-card.dense .fieldset-title {
  padding-inline: 0.5rem;
  margin: 0.25rem 0;
}
</style>
